module.exports = __webpack_public_path__ + "static/img/img-home-faster_zcpp.0c5307e7.png";